var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 18,
    viewBox: "0 0 27.94 27.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pen-to-square-solid",
    d: "M26,6.181a3.085,3.085,0,0,0-4.367,0l-1.66,1.654,5.4,5.4,1.66-1.66a3.085,3.085,0,0,0,0-4.367Zm-16.5,12.13a3.046,3.046,0,0,0-.744,1.208l-1.632,4.9a1.33,1.33,0,0,0,.32,1.356,1.313,1.313,0,0,0,1.356.32l4.9-1.632a3.125,3.125,0,0,0,1.208-.744l9.225-9.23-5.4-5.4Zm-4.213-9.8A5.3,5.3,0,0,0,0,13.806V27.922a5.3,5.3,0,0,0,5.293,5.293H19.409A5.3,5.3,0,0,0,24.7,27.922V22.628a1.764,1.764,0,0,0-3.529,0v5.293a1.763,1.763,0,0,1-1.764,1.764H5.293a1.763,1.763,0,0,1-1.764-1.764V13.806a1.763,1.763,0,0,1,1.764-1.764h5.293a1.764,1.764,0,1,0,0-3.529Z",
    transform: "translate(0 -5.275)",
    fill: "#21827f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.6d185d6451b1ce8e062ce14953d4fa14.svg";
export { ForwardRef as ReactComponent };